import {
  alertsFeature,
  assetsFeature,
  auditFeature,
  catalogFeature,
  createFeatureRegistry,
  devicesFeature,
  gprsFeature,
  notificationsFeature,
  organizationFeature,
  profileFeature,
  rolesFeature,
  sensorAssignmentsFeature,
  subscriptionsFeature,
  usersFeature,
  type AppFeatureDefinition,
  type FeatureRegistry,
} from "@nasam/core";
import { analyticsAndInsightsFeature } from "@nasam/analytics-and-insights";
import { communicationsFeature } from "@nasam/communications";
import { fleetMonitoringFeature } from "@nasam/fleet-monitoring";
import { maintenanceFeature } from "@nasam/maintenance";
import { operationsFeature } from "@nasam/operations";
import { partsAndInventoryFeature } from "@nasam/parts-and-inventory";
import { workforceFeature } from "@nasam/workforce";

/**
 * Local first-party module definitions.
 * Modules are named only at this composition root. The shell consumes their
 * registry contract and remains agnostic to which local modules are present.
 */
/**
 * Non-CORE business modules — each its own workspace package (REBUILD-PLAN
 * §15.5 option B). Unlike the CORE features, each ships its own i18n bundle
 * (its namespace has no static home in @nasam/core/i18n), so this list is
 * also what main.tsx feeds to createAppI18n at boot.
 */
export const verticalFeatures: readonly AppFeatureDefinition[] = [
  fleetMonitoringFeature,
  operationsFeature,
  workforceFeature,
  maintenanceFeature,
  partsAndInventoryFeature,
  analyticsAndInsightsFeature,
  communicationsFeature,
];

export const localFeatures: readonly AppFeatureDefinition[] = [
  // CORE (packages/core) — all share one "core" rail node, merged at render
  // time (see mergeFeatureNavNodes).
  organizationFeature,
  usersFeature,
  rolesFeature,
  assetsFeature,
  devicesFeature,
  sensorAssignmentsFeature,
  gprsFeature,
  alertsFeature,
  catalogFeature,
  subscriptionsFeature,
  auditFeature,
  notificationsFeature,
  // Its own "account" node, opened from the rail's avatar (not a rail icon).
  profileFeature,
  ...verticalFeatures,
];

export const featureRegistry: FeatureRegistry =
  createFeatureRegistry(localFeatures);
